define('common/customiseKnockout',[
    'knockout',
    'knockout.punches',

    'common/ko/projections',
    'common/ko/deferreds',

    'common/ko/fn/arrays',
    'common/ko/fn/asInt',
    'common/ko/fn/contains',
    'common/ko/fn/decode',
    'common/ko/fn/equals',
    'common/ko/fn/find',
    'common/ko/fn/keyBy',
    'common/ko/fn/logic',
    'common/ko/fn/mapToModels',
    'common/ko/fn/notEqual',
    'common/ko/fn/orElse',
    'common/ko/fn/isLessThan',
    'common/ko/fn/isGreaterThan',
    'common/ko/fn/pipe',
    'common/ko/fn/property',
    'common/ko/fn/replacements',
    'common/ko/fn/resetAfter',
    'common/ko/fn/split',
    'common/ko/fn/subscribeAndExec',
    'common/ko/fn/subscribeToChanges',
    'common/ko/fn/trim',
    'common/ko/fn/unwrapped',
    'common/ko/fn/valueFromPromise',
    'common/ko/fn/viewDSL',
    'common/ko/fn/waitForValue',
    'common/ko/fn/withFallback',

    'common/ko/extension/async',
    'common/ko/extension/cash',
    'common/ko/extension/checkEquals',
    'common/ko/extension/delay',
    'common/ko/extension/fallback',
    'common/ko/extension/field',
    'common/ko/extension/fixedPointNumber',
    'common/ko/extension/formattedCardNumber',
    'common/ko/extension/guard',
    'common/ko/extension/lazyList',
    'common/ko/extension/moment',
    'common/ko/extension/smoothValue',
    'common/ko/extension/toggleable',
    'common/ko/extension/validations',
    'common/ko/extension/wrap',

    'common/ko/filters/currencyFilter',
    'common/ko/filters/easeFilter',
    'common/ko/filters/moment',
    'common/ko/filters/wrap'
], function (ko) {

    ko.punches.enableAll();

    /**
     * The same as ko.unwrap but without setting up dependencies
     */
    ko.unwrapWithPeek = function(possibleObservable) {

        if (ko.isObservable(possibleObservable)) {
            return possibleObservable.peek();
        }

        return possibleObservable;

    };

    /**
     * The opposite of ko.unwrap, will ensure a value is an observable
     */
    ko.observify = function(possibleObservable) {

        if (ko.isObservable(possibleObservable)) {
            return possibleObservable;
        }

        return ko.observable(possibleObservable);

    };

    return ko;
});

